import * as auth from './auth';
import * as firebase from './firebase';
import { db } from './firebase';

export { auth, firebase, db };



// WEBPACK FOOTER //
// ./src/firebase/index.js